module.exports = __webpack_public_path__ + "static/media/pla_sli_sig.b4840b99.png";